module.exports = __webpack_public_path__ + "77f3e6e2c159a69a9dea208685a289d3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/long.png
// module id = 1818
// module chunks = 0